export default [
  {
    component: () => import("@/components/faturamento/vendas/acompanhar-vendas.vue"),
    name: "vendas.acompanhar",
    path: "/vendas/acompanhar",
    label: "Acompanhar Vendas",
  },
  {
    component: () => import("@/components/faturamento/vendas/analise-credito.vue"),
    name: "e-commerce.vendas.analise-credito",
    label: "Análise de Crédito",
    path: "/faturamento/analise-credito/:cliente_id/:id_venda?/:representante_id?",
  },
  {
    component: () => import("@/components/faturamento/vendas/analise-credito-representante.vue"),
    name: "e-commerce.vendas.analise-credito-representante",
    label: "Análise de Crédito por Representante",
    path: "/faturamento/analise-credito/representante/:cliente_id/:representante_id",
  },
  {
    component: () => import("@/components/e-commerce/views/GerenciarVendas.vue"),
    name: "e-commerce.vendas.gerenciar",
    path: "/e-commerce/vendas/gerenciar",
    label: "Gerenciar Vendas",
  },
  {
    component: () => import("@/components/e-commerce/views/GerenciarMetas.vue"),
    name: "vendas.equipe.metas-gerenciar",
    path: "/vendas/equipe/metas/gerenciar",
    label: "Gerenciar Metas",
  },
  {
    component: () => import("@/components/e-commerce/views/GerenciarGrupoMetas.vue"),
    name: "vendas.equipe.grupo-metas",
    path: "/vendas/equipe/grupo-metas",
    label: "Gerenciar Grupo de Metas",
  },
  {
    component: () => import("@/components/faturamento/vendas/home-vendas.vue"),
    name: "e-commerce.vendas",
    label: "Vendas",
    path: "/e-commerce/vendas",
  },
  {
    component: () => import("@/components/faturamento/vendas/supervisor/liberar-vendas.vue"),
    name: "vendas.liberar.vendas",
    path: "/vendas/liberar-vendas",
    label: "Liberar Vendas",
  },
  {
    component: () => import("@/components/faturamento/relatorios/produtos-bloqueio.vue"),
    name: "e-commerce.vendas.produtos-bloqueio",
    path: "/e-commerce/vendas/produtos-bloqueio",
    label: "Produtos com Bloqueio de Estoque",
  },
  {
    component: () => import("@/components/faturamento/relatorios/produtos-liberados.vue"),
    name: "e-commerce.vendas.produtos-liberados",
    path: "/e-commerce/vendas/produtos-liberados",
    label: "Produtos Liberados",
  },
  {
    component: () => import("@/components/faturamento/vendas/objetivos-comerciais/objetivos-comerciais-form.vue"),
    name: "vendas.equipe.objetivos-comerciais.novo",
    path: "/vendas/equipe/objetivos-comerciais/novo/:id?",
    label: "Novo Objetivo Comercial",
  },
  {
    component: () => import("@/components/faturamento/vendas/objetivos-comerciais/objetivos-comerciais-reps-form.vue"),
    name: "vendas.equipe.objetivos-comerciais.representante.novo",
    path: "/vendas/equipe/objetivos-comerciais/representante/novo/:id/:mes/:ano/:codigo_supervisor/:cod_representante/:id_objetivo?",
    label: "Novo Objetivo Comercial por Representante",
  },
  {
    component: () => import("@/components/faturamento/vendas/objetivos-comerciais/objetivos-comerciais.vue"),
    name: "vendas.equipe.objetivos-comerciais",
    path: "/vendas/equipe/objetivos-comerciais/gerenciar/:tela?",
    label: "Gerenciar Objetivos Comerciais",
  },
  {
    component: () => import("@/components/catalogos/MenuCatalogo.vue"),
    name: "catalogos",
    path: "/catalogos",
    label: "Catálogos",
  },
  {
    component: () => import("@/components/catalogos/gerenciar-catalogos.vue"),
    name: "catalogos.gerenciar",
    path: "/catalogos/gerenciar",
    label: "Gerenciar Catálogos",
  },
  {
    component: () => import("@/components/catalogos/novo-catalogo.vue"),
    name: "catalogos.novo",
    path: "/catalogos/novo",
    label: "Criar Catálogo",
  },
  {
    component: () => import("@/components/catalogos/novo-catalogo.vue"),
    name: "catalogos.editar",
    path: "/catalogos/novo/:id",
    label: "Editar Catálogo",
  },
];
